export default __webpack_public_path__ + "static/media/sonata-thumbnail.52b2eace.png";